import attendanceApi from '@/api/attendance/attendance';

const state = {
  sessionDetails: null,
  participants: [],
  companies: [],
  loading: false,
  error: null,
  submitLoading: false
};

const getters = {
  sessionDetails: state => state.sessionDetails,
  participants: state => state.participants || [],
  companies: state => state.companies || [],
  loading: state => state.loading,
  error: state => state.error,
  submitLoading: state => state.submitLoading
};

const mutations = {
  SET_SESSION_DETAILS(state, details) {
    state.sessionDetails = details;
  },
  SET_PARTICIPANTS(state, participants) {
    state.participants = participants;
  },
  SET_COMPANIES(state, companies) {
    state.companies = companies;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  },
  SET_SUBMIT_LOADING(state, loading) {
    state.submitLoading = loading;
  }
};

const actions = {
  async getAttendanceSession({ commit }, token) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    
    try {
      const response = await attendanceApi.getAttendanceSession(token);
      
      if (response.data.httpCode === 200) {
        commit('SET_SESSION_DETAILS', response.data.data);
        return response.data;
      } else {
        throw new Error(response.data.error || response.data.message || 'Failed to fetch session details');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || 'An error occurred';
      commit('SET_ERROR', errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async getParticipants({ commit }, { token, company }) {
    try {
      const response = await attendanceApi.getParticipants(token, company);
      
      if (response.data.httpCode === 200) {
        commit('SET_PARTICIPANTS', response.data.data || []);
        return response.data;
      } else {
        throw new Error(response.data.error || response.data.message || 'Failed to fetch participants');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || 'Failed to fetch participants';
      console.error('Error fetching participants:', errorMessage);
      throw new Error(errorMessage);
    }
  },

  async getCompanies({ commit }, token) {
    try {
      const response = await attendanceApi.getCompanies(token);
      
      if (response.data.httpCode === 200) {
        commit('SET_COMPANIES', response.data.data || []);
        return response.data;
      } else {
        throw new Error(response.data.error || response.data.message || 'Failed to fetch companies');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || 'Failed to fetch companies';
      console.error('Error fetching companies:', errorMessage);
      throw new Error(errorMessage);
    }
  },

  async submitAttendance({ commit }, data) {
    commit('SET_SUBMIT_LOADING', true);
    commit('CLEAR_ERROR');
    
    try {
      const response = await attendanceApi.submitAttendance(data);
      
      if (response.data.httpCode === 200) {
        return response.data;
      } else {
        throw new Error(response.data.error || response.data.message || 'Failed to submit attendance');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || 'An error occurred';
      commit('SET_ERROR', errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit('SET_SUBMIT_LOADING', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
